export default { 
    bind(el) {
        el.addEventListener('input', (e) => {
            const value = e.target.value
            // 仅保留数字，并转换为正整数
            e.target.value = value.replace(/[^\d]/g, '')      // 去除非数字
                                .replace(/^0+/, '')          // 禁止以0开头
                                .slice(0, 10);               // 可选：限制最大长度
        });
    }
}